import { SVGProps } from 'react'

export const LineComponentCard = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M5 6H2.5M5 12H2.5M5 18H2.5m9.5 4h1.5c3.771 0 5.657 0 6.828-1.172S21.5 17.771 21.5 14v-4c0-3.771 0-5.657-1.172-6.828S17.271 2 13.5 2H12C8.229 2 6.343 2 5.172 3.172S4 6.229 4 10v4c0 3.771 0 5.657 1.172 6.828S8.229 22 12 22m-1.41-8.26a4.29 4.29 0 0 1 4.82 0c.629.422 2.277 1.282 1.273 2.358-.49.526-1.037.902-1.723.902h-3.92c-.686 0-1.233-.376-1.723-.902-1.004-1.076.644-1.936 1.273-2.357M15 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
